import { z } from "zod";
import { userRoleSchema } from "./enums.js";
import { newPasswordSchema, passwordProblem } from "./password-policy.js";
export const loginSchema = z.object({
    email: z.email("Ingresá un correo válido.").trim().toLowerCase(),
    password: z.string().min(1, "Ingresá tu clave."),
});
export const sessionUserSchema = z.object({
    userId: z.uuid(),
    email: z.string(),
    name: z.string(),
    role: userRoleSchema,
    tenantId: z.uuid(),
});
/**
 * State-changing requests must carry this header. A cross-site form or `fetch` without CORS
 * cannot set a custom header, so its presence proves the request came from our own SPA.
 */
export const CSRF_HEADER = "x-devengo-csrf";
const personFields = {
    email: z.email("Ingresá un correo válido.").trim().toLowerCase(),
    name: z.string().trim().min(1, "El nombre es obligatorio.").max(120),
    role: userRoleSchema,
};
/** A user with an initial password typed by the Dueño: only when the studio cannot send mail. */
export const userCreateSchema = z
    .object({ ...personFields, password: newPasswordSchema })
    .superRefine((value, ctx) => {
    const problem = passwordProblem(value.password, value);
    if (problem)
        ctx.addIssue({ code: "custom", path: ["password"], message: problem });
});
export const userUpdateSchema = z
    .object({
    role: userRoleSchema.optional(),
    status: z.enum(["active", "inactive"]).optional(),
    password: newPasswordSchema.optional(),
})
    .refine((v) => Object.values(v).some((x) => x !== undefined), {
    message: "No hay ningún cambio para aplicar.",
});
/** A user invited by mail: they choose their own password from the link (plan de seguridad). */
export const userInviteSchema = z.object(personFields);
export const changePasswordSchema = z.object({
    currentPassword: z.string().min(1, "Ingresá tu clave actual."),
    newPassword: newPasswordSchema,
});
export const forgotPasswordSchema = z.object({
    email: z.email("Ingresá un correo válido.").trim().toLowerCase(),
});
/** Accepting an invitation or resetting a forgotten password: the mailed token and the new one. */
export const tokenPasswordSchema = z.object({
    token: z.string().min(20).max(200),
    password: newPasswordSchema,
});
export const accessTokenSchema = z.object({ token: z.string().min(20).max(200) });
export const loginCodeSchema = z.object({
    code: z
        .string()
        .trim()
        .regex(/^\d{6}$/, "El código tiene 6 números."),
    remember: z.boolean().default(false),
});
export function isCodeStep(result) {
    return "step" in result && result.step === "code";
}
//# sourceMappingURL=auth.js.map